module.exports = __webpack_public_path__ + "app/modals/set-light-levels.view.html";